<template>
  <client-only>
    <div class="viewing">
      <div class="go-back" @click="router.go(-1)">
        <img src="/icons/back_arrow.png" />
        <div> Go back to dashboard</div>
      </div>
      <div class="viewing-as">
        <div class="view-text">
          Viewing as
        </div>
        <admin-profile-logo></admin-profile-logo>
      </div>
    </div>
    <div class="mt-16">
      <admin-track-header prefix="field"></admin-track-header>
      <main class="main-area">
        <slot></slot> <!-- This is where your main content will go -->
      </main>
      <footer-basic></footer-basic>
    </div>
  </client-only>
</template>
<script setup lang="ts">
import SideMenu from "~/components/core/admin-header/SideMenu.vue";
import AdminHeader from "~/components/core/admin-header/AdminHeader.vue";

import { useUserStore } from "~/composables/useUserStore";
import { onMounted, watch } from "vue";
const { visitingUser } = useUserStore();

import { useRoute, useRouter } from "vue-router";
import LoggedInHeader from "~/components/core/header/LoggedInHeader.vue";
import AdminProfileLogo from "~/components/core/admin-header/AdminProfileLogo.vue";
import AdminTrackHeader from "~/components/core/admin-track-header/AdminTrackHeader.vue";
import FooterBasic from "~/components/core/FooterBasic.vue";
const route = useRoute();
const { setVisiting } = useUserStore();
definePageMeta({
  middleware: 'auth',
  name: 'admin-layout'
});

const initialize = () => {
  setVisiting('', null);
};

onMounted(() => {
  initialize();
});

// Watch route changes
watch(() => route.path, () => {
  initialize();
});
const router = useRouter();
// Handle back/forward navigation
router.afterEach((to, from) => {
  console.log('to', to);
  if (!to.path.includes('artist')) {
    initialize();
  }
});
</script>
<style scoped lang="scss">
.dashboard-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.dashboard-header {
  background-color: #3b3b3b;
  color: white;
  padding: 1rem;
  text-align: center;
}

.dashboard-content {
  display: flex;
  flex: 1;
}

.visiting {
  position: fixed;
  background: white;
  top: 70px;
  right: 0;
  padding: 10px 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, .25);
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.viewing {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: #e3ff00;
  display: flex;
  flex-direction: row;
  z-index: 1;
  justify-content: space-between;
  align-items: center;
  padding: 10px 40px;
  border-bottom: .5px solid #b8b8b8;
  box-shadow: 0 4px 8px rgba(0, 0, 0, .15);
}

.go-back {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: black;
  gap: 10px;
}

.go-back img {
  width: 20px;
}

.viewing-as {
  display: flex;
  font-size: 14px;
  color: #b8b8b8;
  align-items: center;
  font-weight: 300;
}

.main-area {
  flex-grow: 1;
}
</style>